import { DefaultTheme } from 'styled-components';

export default {
  title: 'dark',

  colors: {
    primary: '#0C3A5E',
    textPrimary: '#ffffff',
    secondary: '#1C1E30',
    textSecondary: '#eaeaea',
    background: '#1C1E30',
    textBackground: '#eaeaea',
    error: '#eb6464',
    textError: '#252525',
    warning: '#ffc107',
    textWarning: '#252525',
    info: '#00c0ef',
    textInfo: '#ffffff',
    success: '#00a65a',
    textSuccess: '#ffffff',
    color1: '#ffffff',
    color2: '#87ceeb',
    color3: '#A66EE1',
    color4: '#adff2f',
    color5: '#00ffff',
    color6: '#ff00de',
  },

  metrics: {
    padding: '5px',
    margin: '5px',
    gap: '5px',
    radius: '6px',
    innerRadius: '4px',
    header_height: '40px',
    mobile_small: '320px',
    mobile_medium: '375px',
    mobile_large: '425px',
    tablet_small: '768px',
    tablet_medium: '1024px',
    tablet_large: '1280px',
    desktop_small: '1024px',
    desktop_medium: '1280px',
    desktop_large: '1440px',
    desktop_xlarge: '1680px',
  },
} as DefaultTheme;
